import React, { Component } from "react";
import Swal from "sweetalert2";
import {
  AiOutlinePlus,
  AiOutlineSearch,
  AiOutlineEye,
  AiOutlineCloseCircle,
  AiOutlineClose,
  AiOutlineFileText,
  AiOutlineInbox,
  AiOutlineFilter, 
  AiOutlineShop, 
  AiOutlineEdit,
} from "react-icons/ai";
import "./PreSaleOrdersList.css";
import "../css/dashboard.css";

import { getInformationWithData } from "../services/CABE";
import { getValueCookie } from '../services/cookieService';
// Menu
import { Menu } from "../components/Menu/Menu";

class PreSaleOrdersList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      search: "",
      startDate: "",
      endDate: "",
      currentPage: 1,
      showDetailsModal: false,
      selectedOrder: null,
      orders: [],
      loadingPreSale: false,
      preSalePage: 1,
      preSaleTotalPages: 1,
      pageSize: 20,
      preSaleSearch: "",
      filterStatus: "all",
      userCompany: getValueCookie('CompanyId'),
      companies: [],
      selectedCompany: "all"
    };
  }

  componentDidMount() {
    this.getPreSales(1, "");

    // Only for MY
    if  (this.state.userCompany === '3') {
      this.getCompanies();
    }
  }


  getPreSales = async function (page, search) {
    var currentPage = page || this.state.preSalePage;
    var currentFilterStatus = this.state.filterStatus;
    var currentSearch = typeof search === "string" ? search : this.state.preSaleSearch;

    this.setState({
      loadingPreSale: true
    });

    var data = {
      search: currentSearch,
      page: currentPage,
      status: currentFilterStatus,
      limit: this.state.pageSize,
      company: this.state.selectedCompany
    };

    try {
      const result = await getInformationWithData("/pre-sales/list-order", data);

      if (result && result.data && result.data.status.code === 1) {
        this.setState({
          orders: result.data.data || [],
          /*preSalePage:
            result.pagination && result.pagination.page
              ? result.pagination.page
              : currentPage,
          preSaleTotalPages:
            result.pagination && result.pagination.totalPages > 0
              ? result.pagination.totalPages
              : 1,*/
          loadingPreSale: false
        });
      } else {
        this.setState({
          orders: [],
          preSalePage: currentPage,
          preSaleTotalPages: 1,
          loadingPreSale: false
        });

        Swal.fire({
          icon: "error",
          title: "Error",
          text:
            result &&
            result.status &&
            result.status.Description
              ? result.status.Description
              : "Could not load pre-sale orders."
        });
      }
    } catch (error) {
      this.setState({
        orders: [],
        preSalePage: currentPage,
        preSaleTotalPages: 1,
        loadingPreSale: false
      });

      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Could not load pre-sale orders."
      });
    }
  };

  getCompanies = async function () {
    this.setState({
      loadingPreSale: true
    });

    var data = {};

    try {
      // Request to get active companies
      const result = await getInformationWithData("/company/active-companies", data);
      console.log(result);

      if (result && result.data && result.status.code === 1) {
        this.setState({
          companies: result.data || [],
          loadingPreSale: false
        });
      } else {
        this.setState({
          companies: [],
          loadingPreSale: false
        });

        Swal.fire({
          icon: "error",
          title: "Error",
          text:
            result &&
            result.status &&
            result.status.Description
              ? result.status.Description
              : "Could not load the active companies."
        });
      }
    } catch (error) {
      this.setState({
        companies: [],
        loadingPreSale: false
      });

      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Could not load the active companies."
      });
    }
  };

  normalizeText = (value) => {
    if (!value) return "";
    return value
      .toString()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .trim()
      .toLowerCase();
  };

  handleSearchChange = (e) => {
    // Update state
    this.setState({
      preSaleSearch: e.target.value,
    });
  };

  handleStartDateChange = (e) => {
    this.setState({
      startDate: e.target.value,
      currentPage: 1
    });
  };

  handleEndDateChange = (e) => {
    this.setState({
      endDate: e.target.value,
      currentPage: 1
    });
  };

  handleFilterStatus = (e) => {
    // Update state
    this.setState({
      filterStatus: e.target.value,
    });
  };

  handleCompanyChange = (e) => {
    // Update state
    this.setState({
      selectedCompany: e.target.value,
    });
  }

  apiSearchOrders = () => {
    // Get orders
    this.getPreSales(1, this.state.preSaleSearch);
  };

  goToNewOrder = () => {
    return window.location.href = "/pre-sales/new-order";
  };

  openDetailsModal = async (order) => { 
    // Show loading
    this.setState({ loadingPreSale: true });

    // Request to backend
    const data = {orderNo: order.order_no};

    try {

      const result = await getInformationWithData("/pre-sales/details/order", data);

      this.setState({
        showDetailsModal: true,
        loadingPreSale: false,
        selectedOrder: {...order, items: result.data.data}
      });

    } catch(error) {
      // Hide loading
      this.setState({ loadingPreSale: false });

      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Could not load the order."
      });

    }
  };

  closeDetailsModal = () => {
    this.setState({
      showDetailsModal: false,
      selectedOrder: null
    });
  };

  cancelOrder = async (order) => {
    Swal.fire({
      icon: "warning",
      title: "Cancel order?",
      text: "This action will cancel the selected pre-order.",
      showCancelButton: true,
      confirmButtonText: "Yes, cancel order",
      cancelButtonText: "Back"
    }).then(async (result) => {
      if (result.isConfirmed) {
        // Show loading
        this.setState({ loadingPreSale: true });

        // Request to backend
        const data = {orderNo: order.order_no};

        try {

          const result = await getInformationWithData("/pre-sales/cancel/order", data);

          // Hide loading
          this.setState({ loadingPreSale: false });

          if (result && result.data && result.data.status.code === 1) {
            // Get orders list
            this.getPreSales(1, "");
            // Show confirmation
            Swal.fire({
              icon: "success",
              title: "Ready",
              text: "The order is canceled."
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Error",
              text:
                result &&
                result.status &&
                result.status.Description
                  ? result.status.Description
                  : "Could not cancel the order."
            });
          }

        }catch(error){
          // Hide loading
          this.setState({ loadingPreSale: false });

          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Could not cancel the order."
          });

        }

      }
    });
  };

  convertOrder = async (order) => {
    Swal.fire({
      icon: "warning",
      title: "Convert order to SO?",
      text: "This action will convert the selected pre-order to regular sales order.",
      showCancelButton: true,
      confirmButtonText: "Yes, convert order",
      cancelButtonText: "Back"
    }).then(async (result) => {
      if (result.isConfirmed) {
        // Show loading
        this.setState({ loadingPreSale: true });

        // Request to backend
        const data = {orderNo: order.order_no};

        try {

          const result = await getInformationWithData("/pre-sales/convert/order", data);

          // Hide loading
          this.setState({ loadingPreSale: false });

          if (result && result.data && result.data.status.code === 1) {
            // Get orders list
            this.getPreSales(1, "");
            // Show confirmation
            Swal.fire({
              icon: "success",
              title: "Ready",
              text: "The pre-order is converted."
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Error",
              text:
                result &&
                result.status &&
                result.status.Description
                  ? result.status.Description
                  : "Could not convert the pre-order."
            });
          }

        }catch(error){
          // Hide loading
          this.setState({ loadingPreSale: false });

          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Could not convert the pre-order."
          });

        }

      }
    });
  };

  getFilteredOrders = () => {
    var search = this.normalizeText(this.state.search);
    var startDate = this.state.startDate;
    var endDate = this.state.endDate;

    return this.state.orders.filter(
      function (order) {
        var matchesSearch = true;
        var matchesStartDate = true;
        var matchesEndDate = true;

        if (search) {
          matchesSearch =
            this.normalizeText(order.orderNumber).indexOf(search) !== -1 ||
            this.normalizeText(order.customerNo).indexOf(search) !== -1 ||
            this.normalizeText(order.customerName).indexOf(search) !== -1 ||
            this.normalizeText(order.createdBy).indexOf(search) !== -1 ||
            this.normalizeText(order.status).indexOf(search) !== -1;
        }

        if (startDate) {
          matchesStartDate = order.createdAt >= startDate;
        }

        if (endDate) {
          matchesEndDate = order.createdAt <= endDate;
        }

        return matchesSearch && matchesStartDate && matchesEndDate;
      }.bind(this)
    );
  };

  openPicking = (order) => {
    window.location.href = `/pre-sales/picking?orderNo=${order.order_no}`;
  }

  convertToSO = async (orderNo) => {
    const result = await Swal.fire({
      title: 'Convert to Sales Order?',
      text: `Order ${orderNo} will be converted.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, convert',
      cancelButtonText: 'Cancel'
    });

    if (!result.isConfirmed) return;

    try {
      const data = { orderNo: orderNo };

      const res = await getInformationWithData('/pre-sales/convert/order', data);

      if (res.status.code !== 1) {
        Swal.fire('Error', res.status.Description || 'Error converting order', 'error');
        return;
      }

      Swal.fire('Success', 'Sales Order created successfully', 'success');

      this.getPreSales(1, "");

    } catch (err) {
      console.log(err);
      Swal.fire('Error', 'Unexpected error converting order', 'error');
    }
  };

  paginateList = (list, page) => {
    var pageSize = this.state.pageSize;
    var start = (page - 1) * pageSize;
    var end = start + pageSize;
    return list.slice(start, end);
  };

  getTotalPages = (length) => {
    return Math.max(1, Math.ceil(length / this.state.pageSize));
  };

  changePage = (page) => {
    var filtered = this.getFilteredOrders();
    var totalPages = this.getTotalPages(filtered.length);

    if (page < 1 || page > totalPages) return;

    this.setState({
      currentPage: page
    });
  };

  getStatusStyle = (status) => {
    const base = { borderRadius: '6px', padding: '3px 10px', fontSize: '0.72rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.05em', display: 'inline-block' };
    if (status === "pending")    return { ...base, background: 'rgba(245,158,11,0.1)',  color: '#D97706', border: '1px solid #FDE68A' };
    if (status === "sale order") return { ...base, background: 'rgba(37,99,235,0.1)',   color: '#1e40af', border: '1px solid #BFDBFE' };
    if (status === "picked")     return { ...base, background: 'rgba(16,185,129,0.1)',  color: '#059669', border: '1px solid #A7F3D0' };
    if (status === "invoice")    return { ...base, background: 'rgba(139,92,246,0.1)', color: '#5b21b6', border: '1px solid #DDD6FE' };
    if (status === "canceled")   return { ...base, background: 'rgba(239,68,68,0.08)', color: '#DC2626', border: '1px solid #FECACA' };
    return { ...base, background: '#F1F5F9', color: '#64748B', border: '1px solid #E2E8F0' };
  };

  getStatusClass = (status) => {
    if (status === "pending") return "pol-badge pol-badge--pending";
    if (status === "sale order") return "pol-badge pol-badge--sale-order";
    if (status === "picked") return "pol-badge pol-badge--picked";
    if (status === "invoice") return "pol-badge pol-badge--invoice";
    if (status === "canceled") return "pol-badge pol-badge--canceled";
    return "pol-badge";
  };

  renderPagination = (currentPage, totalPages, onPageChange) => {
    if (totalPages <= 1) return null;
    const btnStyle = (active) => ({
      padding: '0.3rem 0.75rem', borderRadius: '6px', border: 'none', cursor: 'pointer', fontWeight: 700, fontSize: '0.8rem',
      background: active ? 'linear-gradient(135deg, #0f172a, #1e3a8a)' : '#F1F5F9',
      color: active ? 'white' : '#475569',
    });
    return (
      <div style={{ display: 'flex', gap: '0.3rem', justifyContent: 'center', marginTop: '1.5rem', flexWrap: 'wrap' }}>
        <button style={btnStyle(false)} onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 1}>‹ Prev</button>
        {Array.from({ length: totalPages }, (_, i) => i + 1).map(i => (
          <button key={i} style={btnStyle(currentPage === i)} onClick={() => onPageChange(i)}>{i}</button>
        ))}
        <button style={btnStyle(false)} onClick={() => onPageChange(currentPage + 1)} disabled={currentPage === totalPages}>Next ›</button>
      </div>
    );
  };

  // Go to edit screen
  goToEdit = (orderNo) => {
    window.location.href = `/pre-sales/edit-order?orderNo=${orderNo}`;
  };

  render() {
    var filteredOrders = this.getFilteredOrders();
    var visibleOrders = this.paginateList(filteredOrders, this.state.currentPage);
    var totalPages = this.getTotalPages(filteredOrders.length);
    var selectedOrder = this.state.selectedOrder;

    return (
      <div>
        {/* Main menu */}
        <Menu Refresh={this.state.Refresh} Father={this} />

        {this.state.loadingPreSale && (
          <div className="loading-overlay">
            <div className="loading-box">
              <div className="spinner"></div>
              <div className="loading-text">Cargando...</div>
            </div>
          </div>
        )}


        {/* Hero */}
        <div style={{ marginTop: 30, background: 'linear-gradient(135deg, #0f172a 0%, #1e3a5f 50%, #2563EB 100%)', padding: '2rem 2rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '1rem', flexWrap: 'wrap' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            <div style={{ background: 'rgba(255,255,255,0.12)', borderRadius: '12px', padding: '0.75rem', display: 'flex' }}>
              <AiOutlineFileText style={{ color: 'white', fontSize: '1.75rem' }} />
            </div>
            <div>
              <h1 style={{ color: 'white', fontWeight: 800, fontSize: '1.375rem', margin: 0 }}>Pre-orders</h1>
              <p style={{ color: 'rgba(255,255,255,0.6)', margin: 0, fontSize: '0.8rem' }}>Review, search and manage all pre-sale orders</p>
            </div>
          </div>
          <button onClick={this.goToNewOrder} style={{ background: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.3)', borderRadius: '8px', color: 'white', fontWeight: 700, padding: '0.45rem 1.1rem', fontSize: '0.875rem', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: '0.4rem' }}>
            <AiOutlinePlus /> New Order
          </button>
        </div>

        <div className="pol-page" style={{ marginTop: 0, paddingTop: '1rem', background: '#F8FAFC', minHeight: 'calc(100vh - 68px)' }}>
          <div className="pol-shell">

            <div className="pol-toolbar">
              <div className="pol-search">
                <AiOutlineSearch className="pol-search__icon" />
                <input
                  type="text"
                  placeholder="Search by order, customer, creator, or status..."
                  value={this.state.preSaleSearch}
                  onChange={this.handleSearchChange}
                />
                <button onClick={this.apiSearchOrders}>Search</button>
              </div>

              <div className="pol-date-filters">
                <div className="pol-date-field">
                  <AiOutlineShop />
                  <select
                    value={this.state.selectedCompany}
                    onChange={this.handleCompanyChange}
                  >
                    <option value="all">All</option>

                    {this.state.companies.map(function (item) {
                      return (
                        <option key={item.idCompany} value={item.apiPrefix ? item.apiPrefix.replace('/', '') : ''}>
                          {item.name}
                        </option>
                      );
                    })}
                  </select>
                </div>

                <div className="pol-date-field">
                  <AiOutlineFilter />
                  <select
                    value={this.state.filterStatus}
                    onChange={this.handleFilterStatus}
                  >
                    <option value="all">All</option>
                    <option value="pending">Pending</option>
                    <option value="picked">Picked</option>
                    <option value="sale order">Sale Order</option>
                    <option value="invoice">Invoice</option>
                    <option value="canceled">Canceled</option>
                  </select>
                </div>
                {/*<div className="pol-date-field">
                  <AiOutlineCalendar />
                  <input
                    type="date"
                    value={this.state.startDate}
                    onChange={this.handleStartDateChange}
                  />
                </div>

                <div className="pol-date-field">
                  <AiOutlineCalendar />
                  <input
                    type="date"
                    value={this.state.endDate}
                    onChange={this.handleEndDateChange}
                  />
                </div> */}
              </div>
            </div>

            {visibleOrders.length ? (
              <div className="pol-list">
                {visibleOrders.map(
                  function (order) {
                    return (
                      <div className="pol-card" key={order.id}>
                        <div className="pol-card__top">
                          <div className="pol-card__left">
                            {order.company === "Mayaland" ? 
                              <div className="pol-order-icon">
                                <AiOutlineFileText />
                              </div>
                            : 
                              <div className="pol-order-icon-2">
                                <AiOutlineFileText />
                              </div>
                            }

                            <div>
                              <h3>
                                {order.order_no} / {order.company_name}
                              </h3>
                              <p>
                                {order.customer_name} · {order.customer_no}
                              </p>
                            </div>
                          </div>

                          <div className="pol-status-container">
                            <span style={this.getStatusStyle(order.sync_status)}>
                              {order.sync_status}
                            </span>
                          </div>
                        </div>

                        <div className="pol-card__grid">
                          <div className="pol-kv-box">
                            <span>Created By</span>
                            <strong>{order.username}</strong>
                          </div>

                          <div className="pol-kv-box">
                            <span>Date</span>
                            <strong>{order.date}</strong>
                          </div>

                          <div className="pol-kv-box">
                            <span>Order Type</span>
                            <strong>{order.order_type}</strong>
                          </div>

                          <div className="pol-kv-box">
                            <span>Packaging</span>
                            <strong>{order.packing}</strong>
                          </div>

                          <div className="pol-kv-box">
                            <span>Quantity</span>
                            <strong>{order.totalQuantity}</strong>
                          </div>

                          <div className="pol-kv-box">
                            <span>Total Amount</span>
                            <strong>${order.totalAmount}</strong>
                          </div>
                        </div>

                        <div className="pol-card__actions">
                          <button
                            className="pol-secondary-btn"
                            onClick={() => this.openDetailsModal(order)}
                          >
                            <AiOutlineEye />
                            <span>View Details</span>
                          </button>

                          {order.sync_status === 'picked' && this.state.userCompany === '3' ? 
                            <button
                              className="pol-picking-btn"
                              onClick={() => this.convertToSO(order.order_no)}
                            >
                              <AiOutlineInbox />
                              <span>Convert to SO</span>
                            </button>
                          : null}

                          {order.sync_status === 'pending' ? 
                            <div>
                              {/* Edit */}
                              {`${order.id_company}` === `${this.state.userCompany}` ?
                                <button
                                  className="pol-secondary-btn"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    this.goToEdit(order.order_no);
                                  }}
                                >
                                  <AiOutlineEdit />
                                  <span>Edit</span>
                                </button>
                              : null}

                              {/* Picking just for MY */}
                              {this.state.userCompany === '3' ? 
                                <button
                                  className="pol-picking-btn"
                                  onClick={() => this.openPicking(order)}
                                >
                                  <AiOutlineInbox />
                                  <span>Picking</span>
                                </button>
                              : null}

                              {`${order.id_company}` === `${this.state.userCompany}` ? 
                                <button
                                  className="pol-danger-btn"
                                  onClick={() => this.cancelOrder(order)}
                                >
                                  <AiOutlineCloseCircle />
                                  <span>Cancel Order</span>
                                </button>
                              : null}
                            </div>
                          : null}
                        </div>
                      </div>
                    );
                  }.bind(this)
                )}
              </div>
            ) : (
              <div className="pol-empty">
                <div className="pol-empty__icon">
                  <AiOutlineInbox />
                </div>
                <h3>No pre-orders found</h3>
                <p>Try changing the search text or date range.</p>
              </div>
            )}

            {this.renderPagination(
              this.state.currentPage,
              totalPages,
              this.changePage
            )}

            {this.state.showDetailsModal && selectedOrder ? (
              <div className="pol-modal">
                <div className="pol-modal__backdrop" onClick={this.closeDetailsModal} />

                <div className="pol-modal__panel" style={{maxHeight: "calc(100vh - 100px)", marginTop: 80, borderRadius: '16px', overflow: 'hidden'}}>
                  <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)', padding: '1rem 1.5rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <div>
                      <div style={{ color: 'white', fontWeight: 700, fontSize: '1rem' }}>Order Details</div>
                      <div style={{ color: 'rgba(255,255,255,0.6)', fontSize: '0.8rem', marginTop: '2px' }}>Complete information for {selectedOrder.order_no}</div>
                    </div>
                    <button onClick={this.closeDetailsModal} style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,0.7)', fontSize: '1.25rem', cursor: 'pointer', lineHeight: 1 }}>
                      <AiOutlineClose />
                    </button>
                  </div>

                  <div className="pol-modal__content">
                    <div className="pol-details-grid">
                      <div className="pol-detail-card">
                        <h4>General Information</h4>

                        <div className="pol-kv">
                          <span>Order Number</span>
                          <strong>{selectedOrder.order_no}</strong>
                        </div>

                        <div className="pol-kv">
                          <span>Status</span>
                          <strong>{selectedOrder.sync_status}</strong>
                        </div>

                        <div className="pol-kv">
                          <span>Created By</span>
                          <strong>{selectedOrder.username}</strong>
                        </div>

                        <div className="pol-kv">
                          <span>Date</span>
                          <strong>{selectedOrder.date}</strong>
                        </div>

                        <div className="pol-kv">
                          <span>Order Type</span>
                          <strong>{selectedOrder.order_type}</strong>
                        </div>
                      </div>

                      <div className="pol-detail-card">
                        <h4>Customer Information</h4>

                        <div className="pol-kv">
                          <span>Customer No.</span>
                          <strong>{selectedOrder.customer_no}</strong>
                        </div>

                        <div className="pol-kv">
                          <span>Customer Name</span>
                          <strong>{selectedOrder.customer_name}</strong>
                        </div>

                        <div className="pol-kv">
                          <span>Packaging</span>
                          <strong>{selectedOrder.packaging_type}</strong>
                        </div>

                        <div className="pol-kv">
                          <span>Weight Type</span>
                          <strong>{selectedOrder.weight_type}</strong>
                        </div>
                      </div>

                      <div className="pol-detail-card">
                        <h4>Order Totals</h4>

                        <div className="pol-kv">
                          <span>Total Quantity</span>
                          <strong>{selectedOrder.totalQuantity}</strong>
                        </div>

                        <div className="pol-kv">
                          <span>Total Weight</span>
                          <strong>{selectedOrder.totalWeight} lbs</strong>
                        </div>

                        <div className="pol-kv">
                          <span>Total Amount</span>
                          <strong>${selectedOrder.totalAmount}</strong>
                        </div>
                      </div>
                    </div>

                    <div className="pol-items-section">
                      <h4>Products</h4>

                      <div className="tableFixHeadSmall">
                        <table className="table table-clean mb-0">
                          <thead>
                            <tr>
                              <th></th>
                              <th>Item Code</th>
                              <th>Description</th>
                              <th>Ordered Qty</th>
                              <th>Picked Qty</th>
                              <th>Product line</th>
                              <th>Unit Price</th>
                              <th>Total</th>
                            </tr>
                          </thead>
                          <tbody>
                            {selectedOrder.items.map((item) => {
                              return (
                                <tr key={item.id + "-" + item.code}>
                                  <td><img src={item.image_url} style={{ height: 30 }} alt={item.abbreviated_desc}/></td>
                                  <td>{item.item_code}</td>
                                  <td>{item.abbreviated_desc}</td>
                                  <td>{item.quantity}</td>
                                  <td style={{ color: "#15803d" }}>{item.picked_quantity ? item.picked_quantity : 0}</td>
                                  <td>{(item.product_line)}</td>
                                  <td>${item.unit_price}</td>
                                  <td>${(item.unit_price * item.quantity)}</td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  <div className="pol-modal__footer">
                    {selectedOrder.sync_status === 'pending' ? 
                      <button
                        className="pol-danger-btn"
                        onClick={() => this.cancelOrder(selectedOrder)}
                      >
                        <AiOutlineCloseCircle />
                        <span>Cancel Order</span>
                      </button>
                    : null}

                    <button className="pol-secondary-btn" onClick={this.closeDetailsModal}>
                      Close
                    </button>
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}

export default PreSaleOrdersList;
